import DateUtils from "./DateUtils";
//import i18n from "./i18n";
import TypeUtils from "./TypeUtils"

const postcodeMatcher = new RegExp("^[a-zA-Z]{1,2}\\d{1,2}\\s*\\d[a-zA-Z]{2}$");

export default {

  isPostcode(postcode) {
    return postcodeMatcher.test(postcode);
  },

  isPhoneNumber(number, pattern = /^[0-9]{6,14}$/) {
    return pattern.test(number);
  },

  isPastDate(date) {
    return date && DateUtils.diffDays(date) <= 0;
  },

  /**
   * Create a custom validator for a RJSF field
   * @param field
   * @param validator
   * @returns {Function}
   */
  createValidator(field, validator) {

    return (formData, errors) => {
      const fieldValue = formData[field.key];

      if ((field.required || fieldValue) && !validator(fieldValue)) {
        const errorMessage = ""; //i18n.getTranslation(field, 'helpMessage');
        errors[field.key].addError(errorMessage);
      }
    }
  },

  /**
   * Returns a function that validates a checksum. The implementation should be equivalent to that of
   * CheckDigitValidator.validate() in scanstation-android
   *
   * @param checkDigitConfig
   * @param pattern defines a regex string that the input must match
   * @returns {Function}
   */
  createCheckDigitValidator(checkDigitConfig, pattern) {

    if (!checkDigitConfig) {
      return input => false;
    }

    const getNonBlankChar = (string, index) => {
      if (index >= 0 && string.length > index) {
        return string[index].trim();
      }
    };

    const getCharAsInteger = (string, index) => {
      const char = getNonBlankChar(string, index);
      return parseInt(char, 10);
    };

    return input => {
      const regex = pattern ? new RegExp(`^${pattern}$`) : /.*/;
      input = input && input.trim();

      if (!regex.test(input)) {
        return false;
      }

      const checkDigit = getNonBlankChar(input, checkDigitConfig.digitPosition);
      if (!checkDigit) {
        return false;
      }

      const computation = checkDigitConfig.checkDigitComputation;
      let weightedSum = 0;

      for (let i = 0; i < computation.numbers.length; i++) {
        const digit = getCharAsInteger(input, i);

        if (!TypeUtils.isNumeric(digit)) {
          return false;
        }
        const weights = computation.weights;

        if (!weights || weights.length <= i) {
          return false;
        }
        weightedSum += weights[i] * digit;
      }

      let check = weightedSum % computation.modulo;

      if (computation.subtractFrom) {
        check = computation.subtractFrom - check;
      }

      // if the config specifies
      //
      // "checkDigitTransformation": {
      //   "11": "0",
      //   "10": "0"
      // }
      //
      // This mean that if the number is 11 or 10, replace it with 0
      let computedCheckNumber = check.toString();

      if (checkDigitConfig.checkDigitTransformation) {
        const transformed = checkDigitConfig.checkDigitTransformation[computedCheckNumber];
        computedCheckNumber = transformed || computedCheckNumber;
      }
      return checkDigit === computedCheckNumber;
    }
  }
}
